import { axiosClient } from '../../../shared/api';

export const listDocuments = async (query = '') => {
  const response = await axiosClient.get(`/documents${query}`);
  return response.data;
};

export const getDocument = async (documentId) => {
  const response = await axiosClient.get(`/documents/${documentId}`);
  return response.data;
};

export const getDocumentStats = async () => {
  const response = await axiosClient.get('/documents/stats');
  return response.data;
};

export const deleteDocument = async (documentId) => {
  const response = await axiosClient.delete(`/documents/${documentId}`);
  return response.data;
};

export const createDocument = async (documentData) => {
  const response = await axiosClient.post('/documents', documentData);
  return response.data;
};

export const updateDocument = async (documentId, updatedData) => {
  const response = await axiosClient.put(`/documents/${documentId}`, updatedData);
  return response.data;
};
